import { color, spacer } from '@figma/fpl-tokens/tokens.stylex';
import * as stylex from '@stylexjs/stylex';

export const billingCycleToggleStyles = stylex.create({
  toggleGroup: {
    display: 'inline-grid',
    gridAutoFlow: 'column',
    gridAutoColumns: '1fr',
    padding: '2px',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.border,
    borderRadius: '8px',
    backgroundColor: color.bgElevated,
  },
  toggleOption: {
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '140px',
    padding: spacer.spacer2,
    gap: spacer.spacer12px,
    borderRadius: '6px',
    backgroundColor: 'transparent',
    whiteSpace: 'nowrap',
    color: color.textSecondary,
    '--fpl-badge-color': color.textSecondary,
    '--fpl-badge-border-color': color.textSecondary,
    // use same keyboard focus styling as other FPL buttons
    outline: {
      default: 'none',
      ':focus-visible': `1px solid ${color.borderSelected}`,
    },
    outlineOffset: {
      default: 0,
      ':focus-visible': '1px',
    },
  },
  annualToggleOption: {
    paddingInline: spacer.spacer3,
  },
  discountBadge: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  annualDiscountBadge: {
    '--color-bg-brand': 'var(--weave-pricing-promotion-background)',
    '--color-icon-onbrand': 'var(--weave-pricing-badge-text)',
    '--color-text-onbrand': 'var(--weave-pricing-badge-text)',
  },
  inactiveDiscountBadge: {
    '--color-text': color.textSecondary,
  },
  toggleOptionSelected: {
    color: color.text,
    backgroundColor: color.bgHover,
    '--fpl-badge-color': color.text,
    '--fpl-badge-border-color': color.text,
  },
});
